
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/positions",
      function () {
        return require("private-next-pages/system/positions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/positions"])
      });
    }
  